import axios from 'axios';
const getAllQuestionnairesForValidation = () =>
  axios.get(`/questionnaires/get_all_questionnaires_for_validation`);
const getAllQuestionnaires = () =>
  axios.get(`/questionnaires/get_all_questionnaires`);
const getQuestionnaire = ({ companyId, id }) =>
  axios.get(
    `/questionnaires/get_questionnaire/?company_id=${companyId}&id=${id}`,
  );
const getQuestionnaireDocuments = ({ companyId, id }) =>
  axios.get(
    `/questionnaires/get_questionnaire_documents/?company_id=${companyId}&id=${id}`,
  );
const getExtractedDocuments = ({ companyId, id }) =>
  axios.get(
    `/questionnaires/get_extracted_documents/?company_id=${companyId}&id=${id}`,
  );
const getDocumentList = ({ companyId, id }) =>
  axios.get(
    `/questionnaires/get_document_list/?company_id=${companyId}&id=${id}`,
  );
const getQuestionnaireExportedDocs = ({ id }) =>
  axios.get(`/questionnaires/get_exported_documents_list/?id=${id}`);

const getQuestionnaireWithCompany = ({ companyId, id }) =>
  axios.get(
    `/questionnaires/get_questionnaire_with_company?company_id=${companyId}&id=${id}`,
  );
const getQuestionnairesForYear = ({ companyId, year, full }) =>
  axios.get(
    `/questionnaires/get_questionnaires_for_year/?company_id=${companyId}&year=${year}&full=${full}`,
  );

const signAgreement = ({
  companyId,
  signatureId,
  questionnaireId,
  signature,
  clientTime,
  ip,
  userAgent,
}) =>
  axios.post('/questionnaires/sign_agreement', {
    client_time: clientTime,
    ip_address: ip,
    user_agent: userAgent,
    company_id: companyId,
    questionnaire_id: questionnaireId,
    signature_id: signatureId,
    signature,
  });

const getClientQuestionnaires = ({ companyId }) =>
  axios.get(
    `/questionnaires/get_client_questionnaires/?company_id=${companyId}`,
  );

const getExistingQuestionnaires = companyId =>
  axios.get(
    `/questionnaires/get_existing_questionnaires/?company_id=${companyId}`,
  );

const getAllQuestionnairesFromAllClients = ({ year }) =>
  axios.get(
    `/questionnaires/get_all_questionnaires_from_all_clients?year=${year}`,
  );

const exportQuestionnaireToSpreadsheet = ({ id, companyId }) =>
  axios.post(`/questionnaires/export_questionnaire_to_spreadsheet`, {
    id: id,
    company_id: companyId,
  });

const markAsOpened = ({ id, companyId }) =>
  axios.post(`/questionnaires/mark_as_opened`, {
    id: id,
    company_id: companyId,
  });

const uploadEngagementLetter = ({
  documentData,
  companyId,
  questionnaireId,
  documentName,
}) =>
  axios.post(`/questionnaires/upload_engagement_letter`, {
    company_id: companyId,
    document_data: documentData,
    questionnaire_id: questionnaireId,
    document_name: documentName,
  });

const addQuestionnaireComment = ({
  text,
  companyId,
  questionnaireQuestionId,
}) =>
  axios.post(`/questionnaires/add_comment`, {
    text,
    company_id: companyId,
    questionnaire_question_id: questionnaireQuestionId,
  });

const toggleQuestionnaireCommentRemoved = ({
  commentId,
  companyId,
  questionnaireQuestionId,
}) =>
  axios.post(`/questionnaires/toggle_comment_removal`, {
    questionnaire_comment_id: commentId,
    company_id: companyId,
    questionnaire_question_id: questionnaireQuestionId,
  });

const addQuestionToQuestionnaire = ({ companyId, questionnaireId, ...rest }) =>
  axios.post('/questionnaires/add_question_to_questionnaire', {
    company_id: companyId,
    questionnaire_id: questionnaireId,
    ...rest,
  });

const downloadEngagementLetter = ({ companyId, id }) =>
  axios.post(`/questionnaires/download_engagement_letter`, {
    id,
    company_id: companyId,
  });

const deleteQuestionnaireComment = ({
  companyId,
  questionnaireQuestionId,
  questionnaireCommentId,
}) =>
  axios.post(`/questionnaires/delete_comment`, {
    company_id: companyId,
    questionnaire_comment_id: questionnaireCommentId,
    questionnaire_question_id: questionnaireQuestionId,
  });

const deleteQuestionnaire = ({ companyId, id }) =>
  axios.post(`/questionnaires/delete_questionnaire`, {
    id,
    company_id: companyId,
  });

const answerQuestion = ({ id, answer, answerBy, companyId }) =>
  axios.post(`/questionnaires/answer_question`, {
    id,
    answer,
    answer_by: answerBy,
    company_id: companyId,
  });

const saveEntries = ({ questions, questionnaireId, companyId }) =>
  axios.post(`/questionnaires/${questionnaireId}/save_entries`, {
    questions,
    company_id: companyId,
  });

const saveQuestionnaire = ({ submit, ...rest }) =>
  axios.post(`/questionnaires/save_questionnaire`, {
    submit,
    ...rest,
  });

const removeSignature = ({ signatureId, companyId, questionnaireId }) =>
  axios.post(`/questionnaires/remove_signature`, {
    questionnaire_id: questionnaireId,
    signature_id: signatureId,
    company_id: companyId,
  });

const saveQuestionnaires = ({
  questionnaireIds,
  reminderEmailSubject,
  reminderEmailMessage,
  reminderInAppMessage,
  reminderSmsMessage,
  remindersDisabled,
  dueDate,
}) =>
  axios.post(`/questionnaires/save_questionnaires`, {
    questionnaire_ids: questionnaireIds,
    reminder_email_subject: reminderEmailSubject,
    reminder_email_message: reminderEmailMessage,
    reminder_in_app_message: reminderInAppMessage,
    reminder_sms_message: reminderSmsMessage,
    reminders_disabled: remindersDisabled,
    due_date: dueDate,
  });

const saveQuestionnaireOnClientBehalf = ({ submit, ...rest }) =>
  axios.post(`/questionnaires/save_questionnaire_on_client_behalf`, {
    submit,
    ...rest,
  });

const deleteQuestion = ({ id, questionnaireId, companyId }) =>
  axios.post(`/questionnaires/delete_question`, {
    id,
    questionnaire_id: questionnaireId,
    company_id: companyId,
  });

const sendOpenItems = ({
  companyIds,
  taxYear,
  dueDate,
  questionsToCreate,
  name,
  isDraft,
  relevantQuestionnaireId,
  openItemId,
}) =>
  axios.post(`/questionnaires/send_open_items`, {
    company_ids: companyIds,
    tax_year: taxYear,
    due_date: dueDate,
    is_draft: isDraft,
    questions_to_create: questionsToCreate,
    name: name,
    relevant_questionnaire_id: relevantQuestionnaireId,
    open_item_id: openItemId,
  });

const sendQuestionnaireNotifications = ({ questionnaireIds }) =>
  axios.post(`/questionnaires/send_questionnaire_notifications`, {
    questionnaire_ids: questionnaireIds,
  });

const sendQuestionnaires = ({
  companyIds,
  questionnaireTemplateId,
  taxYear,
  sections,
  dueDate,
  questionsToCreate,
  daysUntilDue,
  frequency,
  scheduledDate,
  includePriorYearItems,
  requiredByAllOwners,
  depositRequired,
  depositAmount,
  updateProfile,
  batchSending,
  batchReminder,
  isDocumentPopoutChecklistEnabled,
  isDraft,
  documentDropOffEnabled,
  customTemplateName,
  customEmailSubject,
  customEmailBody,
}) =>
  axios.post(`/questionnaires/send_questionnaires`, {
    sections,
    frequency,
    questionnaire_template_id: questionnaireTemplateId,
    company_ids: companyIds,
    tax_year: taxYear,
    due_date: dueDate,
    questions_to_create: questionsToCreate,
    days_until_due: daysUntilDue,
    first_scheduled_date: scheduledDate,
    include_prior_year_items: includePriorYearItems,
    all_owner_signature_required: requiredByAllOwners,
    deposit_required: depositRequired,
    deposit_amount: depositAmount,
    update_profile_section: updateProfile,
    batch_sending: batchSending,
    batch_reminder: batchReminder,
    document_popout_checklist_enabled: isDocumentPopoutChecklistEnabled,
    is_draft: isDraft,
    document_drop_off_enabled: documentDropOffEnabled,
    custom_template_name: customTemplateName,
    custom_email_subject: customEmailSubject,
    custom_email_body: customEmailBody,
  });

const downloadAttachedDocument = id =>
  axios.post(`/questionnaires/download_attached_document?id=${id}`);

const exportQuestionnaires = ({
  questionnaireIds,
  includeDocuments,
  includeTOC,
  includePages,
  removeNosAndNaAnswers,
  saveAsName,
  saveAsNames,
  documentsToInclude,
  documentsToExclude,
  zipped,
  triggerWebhook,
  convertImagesToPdfs,
  exportToPlatforms,
  format,
}) =>
  axios.post(`/questionnaires/export_questionnaires`, {
    questionnaire_ids: questionnaireIds,
    include_documents: includeDocuments,
    include_toc: includeTOC,
    include_pages: includePages,
    remove_nos_and_na_answers: removeNosAndNaAnswers,
    save_as_name: saveAsName,
    save_as_names: saveAsNames,
    documents_to_include: documentsToInclude,
    documents_to_exclude: documentsToExclude,
    zipped: zipped,
    trigger_webhook: triggerWebhook,
    convert_images_to_pdfs: convertImagesToPdfs,
    export_to_platforms: exportToPlatforms,
    format,
  });
const lockQuestionnaires = ({ questionnaireIds }) =>
  axios.post(`/questionnaires/lock_questionnaires`, {
    questionnaire_ids: questionnaireIds,
  });

const sendQuestionnaireReminders = ({
  questionnaireIds,
  reminderEmailSubject,
  reminderEmailMessage,
  reminderInAppMessage,
  reminderSmsMessage,
  customize,
}) =>
  axios.post(`/questionnaires/send_questionnaire_reminders`, {
    questionnaire_ids: questionnaireIds,
    reminder_email_subject: reminderEmailSubject,
    reminder_email_message: reminderEmailMessage,
    reminder_in_app_message: reminderInAppMessage,
    reminder_sms_message: reminderSmsMessage,
    customize,
  });

const addNewEntry = ({ companyId, questionnaireQuestionId }) =>
  axios.post(`/questionnaires/add_new_entry`, {
    questionnaire_question_id: questionnaireQuestionId,
    company_id: companyId,
  });

const removeEntry = ({ companyId, questionnaireQuestionId, entryNumber }) =>
  axios.post(`/questionnaires/remove_entry`, {
    questionnaire_question_id: questionnaireQuestionId,
    company_id: companyId,
    entry_number: entryNumber,
  });

const createCheckoutSession = ({ id, companyId }) => {
  return axios.post(`/questionnaires/create_checkout_session`, {
    id,
    company_id: companyId,
  });
};

const verifyCheckoutSession = ({ companyId, questionnaireId }) => {
  return axios.post(`/questionnaires/verify_checkout_session`, {
    company_id: companyId,
    questionnaire_id: questionnaireId,
  });
};

const scheduleForExport = ({ forms, companyId }) => {
  return axios.post(`/questionnaires/schedule_for_export`, {
    company_id: companyId,
    forms,
  });
};

const markProfileUpdated = ({ id, companyId }) => {
  return axios.post(`/questionnaires/${id}/mark_profile_updated`, {
    company_id: companyId,
  });
};

const saveSection = ({
  sectionId,
  questionnaireId,
  companyId,
  markedCompleted,
  customElement,
}) => {
  return axios.post(`/questionnaires/save_section`, {
    id: sectionId,
    set_id: questionnaireId,
    company_id: companyId,
    marked_completed: markedCompleted,
    custom_element: customElement,
  });
};

const unsubmitQuestionnaire = ({ id, companyId }) => {
  return axios.post(`/questionnaires/${id}/unsubmit_questionnaire`, {
    company_id: companyId,
  });
};

const submitQuestionnaire = ({ id, companyId }) => {
  return axios.post(`/questionnaires/${id}/submit_questionnaire`, {
    company_id: companyId,
  });
};

const attachToQuestionnaire = ({ id, companyId, extractedDocumentIds }) => {
  return axios.post(`/questionnaires/${id}/attach_to_questionnaire`, {
    company_id: companyId,
    extracted_document_ids: extractedDocumentIds,
  });
};

const detachFromQuestionnaire = ({ companyId, extractedDocumentIds }) => {
  return axios.post(`/questionnaires/detach_from_questionnaire`, {
    company_id: companyId,
    extracted_document_ids: extractedDocumentIds,
  });
};

const generateQuestionnaireLink = ({ id, companyId, userId }) => {
  return axios.post(`/questionnaires/${id}/generate_questionnaire_link`, {
    company_id: companyId,
  });
};

const sendCustomStatusChange = ({
  questionnaireIds,
  customEmailSubject,
  customEmailMessage,
  customSmsMessage,
}) => {
  return axios.post(`/questionnaires/send_custom_status_change`, {
    questionnaire_ids: questionnaireIds,
    custom_email_subject: customEmailSubject,
    custom_email_message: customEmailMessage,
    custom_sms_message: customSmsMessage,
  });
};

export default {
  getExtractedDocuments,
  getQuestionnaire,
  getQuestionnaireWithCompany,
  getAllQuestionnaires,
  getAllQuestionnairesForValidation,
  saveQuestionnaire,
  saveQuestionnaireOnClientBehalf,
  deleteQuestion,
  addQuestionnaireComment,
  toggleQuestionnaireCommentRemoved,
  deleteQuestionnaireComment,
  getAllQuestionnairesFromAllClients,
  sendQuestionnaires,
  deleteQuestionnaire,
  sendQuestionnaireReminders,
  exportQuestionnaires,
  answerQuestion,
  saveEntries,
  getDocumentList,
  getQuestionnaireExportedDocs,
  getQuestionnairesForYear,
  getClientQuestionnaires,
  downloadEngagementLetter,
  uploadEngagementLetter,
  addQuestionToQuestionnaire,
  sendOpenItems,
  addNewEntry,
  removeEntry,
  lockQuestionnaires,
  exportQuestionnaireToSpreadsheet,
  markAsOpened,
  saveSection,
  attachToQuestionnaire,
  detachFromQuestionnaire,
  downloadAttachedDocument,
  saveQuestionnaires,
  createCheckoutSession,
  verifyCheckoutSession,
  scheduleForExport,
  markProfileUpdated,
  removeSignature,
  unsubmitQuestionnaire,
  getExistingQuestionnaires,
  generateQuestionnaireLink,
  signAgreement,
  submitQuestionnaire,
  sendCustomStatusChange,
  getQuestionnaireDocuments,
  sendQuestionnaireNotifications,
};
